import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tooltip } from '@material-ui/core'
import BrandedDocument from '../../../molecules/BrandedDocument'
import DenaliLogo from '../../../../apps/aiApp/Assistant/common/DenaliLogo'
import Icon from '../../../atoms/Icon'

const DEFAULT_ACTION_ICON_URL = '/img/catalog_api_pb.svg'

function ActionTemplateLink ({ template }) {
  const badges = useMemo(() => {
    const result = []
    if (!template.enabled) {
      result.push((
        <div key='disabled'>
          <Tooltip title='Disabled'>
            <div className='px-1 bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <Icon customSize='20px' name='block' style={{ fill: 'var(--color-warning-500)' }} />
            </div>
          </Tooltip>
        </div>
      ))
    }
    if (template.visibleToAi) {
      result.push((
        <div key='ai_visible'>
          <Tooltip title='AI-Visible'>
            <div className='px-1 bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <DenaliLogo size='20px' />
            </div>
          </Tooltip>
        </div>
      ))
    }
    if (!template.definitionVersionId) {
      result.push((
        <div key='no_definition'>
          <Tooltip title='No Active Definition'>
            <div className='px-1 bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <Icon customSize='20px' name='warning' style={{ fill: 'var(--color-danger-400)' }} />
            </div>
          </Tooltip>
        </div>
      ))
    }
    return result
  }, [template])

  const imageUrl = template.icon || DEFAULT_ACTION_ICON_URL

  return (
    <Link to={`/admin/denali/catalog/actions/${template.actionTemplateId}`} className='catalog-datasource-link'>
      <BrandedDocument
        name={template.name}
        imageUrl={imageUrl}
        imagePadded
        badges={badges}
      />
    </Link>
  )
}

ActionTemplateLink.propTypes = {
  template: PropTypes.shape({
    actionTemplateId: PropTypes.number,
    code: PropTypes.string,
    name: PropTypes.string,
    enabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    visibleToAi: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    definitionVersionId: PropTypes.string,
    icon: PropTypes.string
  })
}

export default ActionTemplateLink
